import React, { useState } from "react";
import { P } from "../Texts";
import { DarkFormFieldStyle, DarkFormInput } from "./input.styles";

import eyeIcon from "../../../assets/images/eye.svg";
import eyeOffIcon from "../../../assets/images/eye-off.svg";

export const PasswordInput = React.forwardRef(
  (
    {
      className,
      containerClass,
      data_testid,
      hideIcon,
      iconClick,
      iconBefore,
      iconBeforeClass,
      iconBeforeClick,
      id,
      inputClassName,
      label,
      name,
      required,
      defaultValue,
      placeholder,
      disabled,
      value,
      onChange,
    },
    ref,
  ) => {
    const [passwordType, setPasswordType] = useState("password");
    const [show, setShow] = useState(false);

    const showPassword = () => {
      if (show) {
        setShow(false);
        setPasswordType("password");
      } else {
        setShow(true);
        setPasswordType("text");
      }
    };

    return (
      <div className={`mb-6 ${containerClass}`}>
        {label && (
          <label htmlFor={id}>
            <P fontSize="14px" fontFamily="semi" color="#47495C" className="mb-2">
              {label}
              {required && (
                <span
                  className=""
                  style={{
                    color: "#E62250",
                  }}
                >
                  *
                </span>
              )}
            </P>
          </label>
        )}

        <DarkFormFieldStyle className={className}>
          {iconBefore && (
            <div
              className="h-full flex-shrink-0 py-2 px-4"
              onClick={iconBeforeClick}
            >
              <img src={iconBefore} alt="" className={iconBeforeClass} />
            </div>
          )}

          <DarkFormInput
            type={passwordType}
            ref={ref}
            id={id}
            name={name}
            defaultValue={defaultValue}
            className={`flex-grow ${inputClassName}`}
            placeholder={placeholder}
            data-testid={data_testid}
            disabled={disabled}
            value={value}
            onChange={onChange}
          />
          {!hideIcon && (
            <div
              className="h-full flex-shrink-0 py-2 px-4 cursor-pointer"
              onClick={showPassword}
            >
              <img src={!show ? eyeIcon : eyeOffIcon} alt="" />
            </div>
          )}
        </DarkFormFieldStyle>
      </div>
    );
  },
);
